import { useAlertStore } from '@/stores/alert'
import { t } from '@/utils/i18nHelper'

let pendingPwaUpdate = null

async function showPwaUpdateConfirm({ refresh }) {
  const alertStore = useAlertStore()
  const confirmed = await alertStore.confirm(t('pwa.updateMessage'), {
    title: t('pwa.updateTitle'),
    type: 'info'
  })

  if (confirmed && typeof refresh === 'function') {
    refresh()
  }
}

/**
 * Liga atualizações do service worker ao GlobalAlert (Pinia).
 * Deve ser chamado após app.use(createPinia()).
 */
export function initPwaUpdateHandler() {
  if (typeof window === 'undefined') return

  window.__onPWAUpdateAvailable = showPwaUpdateConfirm

  if (pendingPwaUpdate) {
    const payload = pendingPwaUpdate
    pendingPwaUpdate = null
    showPwaUpdateConfirm(payload)
  }
}

export function queuePwaUpdateIfNoHandler(payload) {
  if (typeof window.__onPWAUpdateAvailable === 'function') {
    window.__onPWAUpdateAvailable(payload)
    return
  }
  pendingPwaUpdate = payload
}
